<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf"  [ngStyle]="{'background-image':'url(' + newsSingle?.image + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="news-bottom-section cf">
       <div class="container">
           <div class="news-bottom-detail cf">
                <div class="titel-box">
	      	 		<h2 class="titel-name">News</h2>
	      	 	</div>
                <div class="new-single-detail">
                    <div class="new-single-content">
                        <h3>{{newsSingle?.title}}</h3>
                        <p>{{newsSingle?.date | amDateFormat: "DD MMMM YYYY"}}</p>
                        <!-- <div [innerHTML]="newsSingle?.description">
                            
                        </div> -->
                        <div [innerHTML]="safeDescription"></div>
                        <!-- <p>The 2021 AGM of Leicestershire County Cricket Club is to be held online via Zoom on Tuesday 30th March 2021 at 7.30pm. The Meeting Host and Meeting Chairman will be present at the Uptonsteel County Ground, Grace Road, Leicester, LE2 8EB. Members will be in attendance through Zoom.</p>
                        <p>Paperwork has been sent to Members by post. Please note that a copy of the Redline version (i.e. one which shows the changes proposed to be made) of the Club Rules as proposed to be amended has been mailed to Members and the Redline version and a Clean version of the Club Rules as amended (if the relevant resolutions are passed at the AGM) are available to download in the Governance section of our website.</p>
                        <p>If you have any questions relating to receiving the paperwork, or if you wish to be sent a direct link to the AGM, please email Administration & Governance Manager Jacqui Dean</p> -->
                    </div>
                    <div class="new-single-slider-section" *ngIf="newsList?.length > 0">
                        <div class="titel-box">
                            <h2 class="titel-name">More News</h2>
                        </div>
                        <div class="new-single-slider-main">
                            <div class="new-single-slider-detail">
                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidenewsConfig">
                                    <div ngxSlickItem class="new-single-slider-box slide" *ngFor="let news of newsList; let i = index">
                                        <a [routerLink]="['/news', news?.slug]">
                                            <div class="new-single-slider-box-image">
                                                <img [src]="news?.thumbnail_image">
                                            </div>
                                            <div class="new-single-slider-box-overlay">
                                                <p>{{news?.title}}</p>
                                            </div>
                                        </a>
                                    </div>
                                    
                                </ngx-slick-carousel>
                            </div>
                        </div>
                    </div>
                </div>
	      	 	
           </div> 
       </div>
    </div>
</section><!-- page ends-->